import 'swiper/swiper-bundle.css'
import './frontend.scss'

// import './vue/vue-router'
import './vue/filter'
import Router from './util/Router'
// import masterDataPageGarage from './routes/home'
/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */

import common from './routes/common'
import home from './routes/home'
import postTypeArchiveNews from './routes/news'
import singleNews from './routes/singleNews'
import postTypeArchiveInformation from './routes/information'
import pageTemplateTemplateSurvey from './routes/survey'

const routes = new Router({
	common,
	home,
	postTypeArchiveNews,
	singleNews,
	postTypeArchiveInformation,
	pageTemplateTemplateSurvey,
})

window.addEventListener('DOMContentLoaded', () => {
	routes.loadEvents()
})
